import { envConfigs } from '../../../envConfigs';
import { handleServiceCall } from '../../app/util/fetch-utils';

// export learner Dashboard
export const exportUserReport = (userId, startDate, endDate, token) => {
  const prismUri = envConfigs.prismApiHost + '/reports/spectrum/user-report';

  const postObject = {
    user: userId,
    start: startDate,
    end: endDate
  };

  const postString = JSON.stringify(postObject);

  return fetch(prismUri, {
    method: 'POST',
    body: postString,
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + token,
      'Cache-Control': 'no-store, no-cache, must-revalidate, post-check=0, pre-check=0',
      Pragma: 'no-cache',
      'Content-Type': 'application/json;charset=UTF-8'
    }
  }).then((response) => {
    return handleServiceCall(response);
  });
};

// check if the report with id is complete
export const getUserReportStatus = (reportId, token) => {
  const prismUri = envConfigs.prismApiHost + '/reports/report-jobs/' + reportId;
  return fetch(prismUri, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + token,
      'Cache-Control': 'no-store, no-cache, must-revalidate, post-check=0, pre-check=0',
      Pragma: 'no-cache',
      'Content-Type': 'application/json;charset=UTF-8'
    }
  }).then((response) => {
    return handleServiceCall(response);
  });
};

// trigger the download
export const downloadUserReport = (reportId, format, token) => {
  const formattedUrl =
    envConfigs.prismApiHost +
    '/reports/report-jobs/' +
    reportId +
    '/download?format=' +
    format +
    '&access_token=' +
    token;
  window.location.assign(formattedUrl);
};



// WEBPACK FOOTER //
// ./src/modules/launchpad/services/export-api.js